import './App.scss';
import 'bootstrap/dist/js/bootstrap.bundle'
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import Login from './views/pages/Login';
import ThankYou from './views/pages/stepform/ThankYou';
import Stepform from './views/pages/stepform/Stepform';
import ApplicationToken from './views/pages/ApplicationToken';
import Signup from './views/pages/SignUp';

import 'react-toastify/dist/ReactToastify.css';
toast.configure();

function App() {

	let isAuthenticated;
	if (localStorage.getItem('user')) {
		const item = JSON.parse(localStorage.getItem('user'));
		const now = new Date();
		if (item.expiry > (now.getTime() / 100)) {
			localStorage.removeItem('user')
			localStorage.removeItem('formCount');
		} else {
			isAuthenticated = item.token;
		}
	}

	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route path="/" exact element={!isAuthenticated ? <Login /> : <Navigate to="/stepform" />} />
					<Route path="/stepform" exact element={isAuthenticated ? <Stepform /> : <Navigate to="/" />} />
					<Route path="/thankyou" exact element={<ThankYou />} />
					<Route path="/application/:token" exact element={<ApplicationToken />} />
					<Route path="/signup" exact element={<Signup />} />
					<Route path="/signup/unit-trust" exact element={<Signup planType={'unit_trust'} />} />
					<Route path="/signup/hedge-fund" exact element={<Signup planType={'hedge_fund'} />} />
				</Routes>
			</BrowserRouter>
		</>
	);
}

export default App;
